<div
  class="h-full w-full rounded-2xl bg-white/90 p-4"
  [class.cursor-pointer]="canClick()"
>
  <div
    [style.background-color]="color()"
    class="mb-6 flex aspect-square w-14 flex-col items-center justify-center rounded-xl"
  >
    <span class="flex flex-col items-center text-xl text-white md:text-2xl">
      <ng-content select="[icon]"></ng-content>
    </span>
  </div>
  <h3 class="text-2xl font-bold md:text-4xl">
    <ng-content></ng-content>
  </h3>
  <div class="text-sm overflow-ellipsis text-gray-600 md:text-base">
    <ng-content select="[title]"></ng-content>
  </div>
</div>
